import { createAction, props } from '@ngrx/store';

export const updateName = createAction('[Complete] update name', props<{displayName: any}>());
export const updatePassword = createAction('[Complete] update password', props<{newPassword: any}>());
export const updateMaxMonthlyOrders = createAction('[Complete] update max monthly orders', props<{maxMonthlyOrders: any}>());
export const updatePhone = createAction('[Complete] update phone', props<{phone: any}>());
export const updateAll = createAction('[Complete] update all', props<{payload: any}>());
export const hideExtraData = createAction('[Complete] hide extra data', props<{hideExtraData: any}>());
export const saveData = createAction('[Complete] save data');
export const updateWeakPassPopover = createAction('[Complete] update weak pass popover', props<{weakPassPopover: any}>());
export const updateSaving = createAction('[Complete] update saving', props<{saving: any}>());
